;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('listSummary', SummaryDirective)

  SummaryController.$inject = ['$scope', '$state']

  function SummaryController ($scope, $state) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        statuses: [
          {
            name: 'paid',
            classes: 'noselect rounded mdi icon-green mdi-check-all status-icon',
            label: 'Payé(e)s'
          },
          {
            name: 'invoiced',
            classes: 'noselect rounded mdi icon-green mdi-currency-eur status-icon',
            label: 'Envoyés en facturation'
          },
          {
            name: 'partly_paid',
            classes: 'noselect rounded mdi icon-orange mdi-forward status-icon',
            label: 'Partiellement payées'
          },
          {
            name: 'validated',
            classes: 'noselect rounded mdi icon-blue mdi-check status-icon',
            label: 'Validé(e)s'
          },
          {
            name: 'dunning',
            classes: 'noselect rounded mdi icon-yellow mdi-alert status-icon',
            label: 'Relances'
          },
          {
            name: 'litigation',
            classes: 'noselect rounded mdi icon-red mdi-close status-icon',
            label: 'Litiges'
          },
          {
            name: 'sent',
            classes: 'noselect rounded mdi icon-blue mdi-send status-icon',
            label: 'Envoyé(e)s'
          },
          {
            name: 'signed',
            classes: 'noselect rounded mdi icon-green mdi-check-all status-icon',
            label: 'Signés'
          },
          {
            name: 'refused',
            classes: 'noselect rounded mdi icon-red mdi-close status-icon',
            label: 'Refusés'
          },
          {
            name: 'draft',
            classes: 'noselect rounded mdi icon-yellow mdi-pencil status-icon',
            label: 'Brouillons'
          }
        ],
        getListCount: getListCount,
        goTo: goTo
      })
      init()
    }

    function init () {
      $scope.$watch(function () {
        return self.list
      }, function () {
        self.sortedList = _(self.list).map('status').countBy().value()
      })
    }

    function getListCount (statusName) {
      if (!self.sortedList) { return }
      return self.sortedList[statusName] || ''
    }

    function getInvoiceRef (statusName) {
      if (!self.sortedList) { return }
      return _(self.list)
        .map(function (elt) {
          if (elt.status === statusName) {
            return elt.invoiceRef
          }
        }).compact().uniq().value()
    }

    function getId (statusName) {
      if (!self.sortedList) { return }
      return _.get(_.find(self.list, function (elt) {
        return elt.status === statusName
      }), '_id')
    }

    function goTo (concern, status) {
      var config = {
        client: self.entity,
        label: self.label,
        status: status,
        invoiceRef: getInvoiceRef(status)
      }
      if (getListCount(status) === 1) {
        $state.go(self.concern + '.show', { id: getId(status) })
      } else {
        $state.go(self.concern + '.list', { linkedSearch: config })
      }
    }
  }

  SummaryDirective.$inject = []

  function SummaryDirective () {
    return {
      restrict: 'E',
      bindToController: {
        list: '=',
        entity: '@',
        label: '@',
        concern: '@'
      },
      controller: SummaryController,
      templateUrl: '/app/common/directives/list-summary/list-summary.html',
      controllerAs: 'summary',
      scope: true
    }
  }
})(window.angular, window._, window.moment)
